// Dev-only tenant override. Lets you flip Siro ↔ FieldPro at runtime via a
// cookie + a banner toggle, without restarting the dev server. The override
// is silently ignored in production so the build-time tenant remains the
// single source of truth for shipped deployments.

import { isTenant, type Tenant } from "./tenant"

export const DEV_TENANT_COOKIE = "dev-tenant-override"

export const isDevTenantOverrideAllowed = (): boolean =>
  process.env.NODE_ENV !== "production"

export const parseDevTenantOverride = (
  raw: string | undefined | null,
): Tenant | null => {
  if (!isDevTenantOverrideAllowed()) return null
  if (!raw) return null
  return isTenant(raw) ? raw : null
}
